import { useState } from "react";
import { Job } from "../../../interfaces/job.interfaces";
import { EJobStatuses } from "../../../enum/job.enums";
import type { TimeRangePreset, BillingFilter } from "../board/filters/job-event-filters.types";

/* ───────────────────────── Types ───────────────────────── */

export type JobEventsController = {
  search: string;
  status?: EJobStatuses;
  timeRange?: TimeRangePreset;
  customStartDate?: string;
  customEndDate?: string;
  billingStatus?: BillingFilter;

  setSearch: (value: string) => void;
  setStatus: (value?: EJobStatuses) => void;
  setTimeRange: (value?: TimeRangePreset) => void;
  setCustomStartDate: (value?: string) => void;
  setCustomEndDate: (value?: string) => void;
  setBillingStatus: (value?: BillingFilter) => void;

  job: Job;
};

/* ───────────────────────── Controller ───────────────────────── */

export function useJobEventsController(job: Job): JobEventsController {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState<EJobStatuses | undefined>(undefined);
  const [timeRange, setTimeRange] = useState<TimeRangePreset | undefined>(undefined);
  const [customStartDate, setCustomStartDate] = useState<string | undefined>(undefined);
  const [customEndDate, setCustomEndDate] = useState<string | undefined>(undefined);
  const [billingStatus, setBillingStatus] = useState<BillingFilter | undefined>(undefined);

  return {
    search,
    status,
    timeRange,
    customStartDate,
    customEndDate,
    billingStatus,
    setSearch,
    setStatus,
    setTimeRange,
    setCustomStartDate,
    setCustomEndDate,
    setBillingStatus,
    job,
  };
}
